const APP_CONFIG = {
  loadingDuration: 1000
};

export default APP_CONFIG;
